var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 18,
    fill: "#C7D6D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5274_3290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.75C22.5711 16.75 24.25 18.4289 24.25 20.5V35.5C24.25 37.5711 22.5711 39.25 20.5 39.25C18.4289 39.25 16.75 37.5711 16.75 35.5V20.5C16.75 18.4289 18.4289 16.75 20.5 16.75Z",
    stroke: "#364D4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 16.75C37.5711 16.75 39.25 18.4289 39.25 20.5V35.5C39.25 37.5711 37.5711 39.25 35.5 39.25C33.4289 39.25 31.75 37.5711 31.75 35.5V20.5C31.75 18.4289 33.4289 16.75 35.5 16.75Z",
    stroke: "#364D4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5929 18.1268L32.5929 18.1268L32.5962 18.1232C32.7803 17.9196 32.9496 17.744 33.1243 17.601C35.5643 15.611 39.2411 17.3522 39.25 20.5012C39.2497 21.4591 38.8837 22.4157 38.1497 23.1497L30.4706 30.8288L30.4697 30.8297L28 33.2911L25.5303 30.8297L25.5294 30.8288L17.8503 23.1497C17.1163 22.4156 16.7503 21.459 16.75 20.501C16.7591 17.3436 20.4348 15.6099 22.8759 17.6012L22.8818 17.6059L22.8878 17.6106C23.0706 17.7537 23.2315 17.914 23.3795 18.0949L23.3929 18.1112L23.4071 18.1268L23.5156 18.2451C24.7147 19.5688 26.3597 20.23 28 20.23C29.6403 20.23 31.2853 19.5688 32.4844 18.2451C32.4849 18.2445 32.4855 18.2439 32.486 18.2433L32.5929 18.1268Z",
    stroke: "#364D4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5274_3290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about_us.020f60a2c5c312a6ffe225ec0f8f19fc.svg";
export { ForwardRef as ReactComponent };